
import { MapLocation } from '@/types/location';

// Fit You Gym Locations
export const fitYouGyms: MapLocation[] = [
  {
    id: 9001,
    name: "Fit You Gym - Riyadh (Al Nahda)",
    type: "Gym",
    devices: 4,
    coordinates: [24.776912971780458, 46.82293964295162],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 9002,
    name: "Fit You Gym - Riyadh (Laban)",
    type: "Gym",
    devices: 4,
    coordinates: [24.650458698097683, 46.55748258941931],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 9003,
    name: "Fit You Gym - Riyadh (Al Shefa)",
    type: "Gym",
    devices: 5,
    coordinates: [24.5555161254079, 46.71550387487862],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 9004,
    name: "Fit You Gym - Riyadh (As Suwedi)",
    type: "Gym",
    devices: 4,
    coordinates: [24.566718320006444, 46.624756164417654],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
